module.exports = __webpack_public_path__ + "img/jumpintokeyboarding.93ee8b6e.png";